module.exports = "<div id=\"extr-page\">\r\n<router-outlet></router-outlet>\r\n</div>\r\n"